export default __webpack_public_path__ + "static/media/diamond-circle-light.a1c19d83.svg";